import { history } from '../../../history';

import { isUtmParamKey } from './utmParams';

export const cleanupUtmParams = () => {
  const url = new URL(window.location.href);

  [...url.searchParams.keys()].forEach((key) => {
    if (isUtmParamKey(key)) {
      url.searchParams.delete(key);
    }
  });

  history.replace(url.pathname + url.search);
};
